module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corvus/crv_vis-5e4e3646f6b680e1ca21e537d6ccf590.jpg";